<div class="page-inner-body portlet light" [ngClass]="!isAuthenticated? 'container': ''">
    <div class="portlet-body">
        <!--Shown if the user is not logged-in-->
        <div class="d-flex justify-content-between align-items-center" *ngIf="!isAuthenticated">
            <a href="javascript:void(0);" routerLink="/" class="text-center py-2">
                <img src="assets/images/thumb_AFP-logo-v02-noTagline-800.png" height="65" />
            </a>
            <div class="fs-5">
                {{ 'viewArtwork.alreadyAMember' | transloco }}
                <a href="javascript:void(0);" routerLink="/login" class="text-lg py-2">
                    {{ 'viewArtwork.login' | transloco }}
                </a>
            </div>
        </div>
        <div class="table-toolbar">
            <ng-container *ngIf="items && items.length > 0">
                <div class="card flex justify-content-center text-center " style="border: none;">
                    <!-- Breadcrumb when items are available -->
                    <p-breadcrumb class="no-border max-w-full " [model]="items" [home]="home"></p-breadcrumb>
                </div>
            </ng-container>
            <div class="row mt-3 p-2" *ngIf="selectedItem">
                <!-- Product Detail Section -->
                <div class="text-bg-light border py-2" *ngIf="selectedItem.Name">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="justify-content-start">
                            <label class="form-label fw-bold">{{ 'viewArtwork.productDetail' | transloco }}</label>
                            <div class="text-muted small fst-italic">
                                <i class="fa fa-info-circle"></i> {{ 'viewArtwork.sectionKeyDetails' | transloco }}
                                <div class="text-muted fst-italic mt-2 text-start" *ngIf="selectedItem.CreatedDate">
                                    {{ 'viewArtwork.createdOn' | transloco: { date: (selectedItem.CreatedDate | date : 'dd/MM/yyyy HH:mm a') } }}
                                </div>
                            </div>
                        </div>
                        <div class="d-flex flex-column justify-content-end align-items-center">
                            <!-- Action Buttons Section -->
                            <div class="d-flex flex-wrap gap-2 align-items-center">
                                <!-- Sell Product and Chat Buttons -->
                                <div *ngIf="selectedItem.IsGalleryProduct && !isProductSold" class="d-flex gap-2">
                                    <button pButton type="button" [label]="'viewArtwork.sellProduct' | transloco"
                                        class="p-button-primary p-button-outlined"
                                        (click)="onMarkProductAsSold($event)">
                                    </button>
                                    <button pButton type="button" icon="fa fa-comments" [label]="'viewArtwork.chat' | transloco"
                                        class="p-button-outlined" size="small" (click)="ChatwithArtist()">
                                    </button>
                                    <ng-container *ngIf="isFacebook || isInstagram">
                                        <button pButton type="button" [label]="'viewArtwork.newSocialPost' | transloco"
                                            class="p-button-primary p-button-outlined"
                                            (click)="onOpenSocialPostDailog()">
                                        </button>
                                    </ng-container>
                                </div>

                                <!-- Share Button -->
                                <button pButton type="button" class="p-button-primary p-button-outlined  gap-2"
                                    [label]="'viewArtwork.share' | transloco" (click)="onProductShareDailog()">
                                    <i class="fa fa-light fa-share mt-1 me-1"></i>
                                </button>
                                <div *ngIf="authConfig.IsGallery && selectedItem.IsGalleryProduct && !isProductSold">
                                    <button pButton type="button" icon="pi pi-bars"
                                        class="p-button-rounded p-button-info"
                                        (click)="sidebarVisible = !sidebarVisible">
                                    </button>
                                </div>
                                <!-- Activity Log Button -->
                                <div
                                    *ngIf="isAuthenticated && !(authConfig?.IsSuperAdmin || authConfig?.IsAdministrator)">
                                    <button pButton type="button" class="p-button-primary p-button-outlined Activitylog"
                                        (click)="openActivityLogSidebar()">
                                        {{ 'viewArtwork.activityLog' | transloco }}
                                        <i class="pi pi-angle-right mt-1"></i>
                                    </button>
                                </div>


                            </div>
                        </div>

                    </div>
                </div>
                <!-- Left column -->
                <div class="col-7 px-0 pe-2">
                    <div class="d-flex justify-content-start align-items-start p-3 bg-white rounded shadow-sm border border-light"
                        style="transition: box-shadow 0.3s;">
                        <!-- Profile Image with Shadow and Border -->
                        <img *ngIf="selectedItem.UserImgUrl" [src]="selectedItem.UserImgUrl"
                            class="rounded-circle me-3 border border-secondary cursor-pointer d-block d-md-none"
                            [style.height.px]="60" (click)="viewArtistDetails(selectedItem.ArtistUserName)" />

                        <img *ngIf="selectedItem.UserImgUrl" [src]="selectedItem.UserImgUrl"
                            class="rounded-circle me-3 border border-secondary cursor-pointer d-none d-md-block"
                            height="100" [alt]="'viewArtwork.profileImage' | transloco" (click)="viewArtistDetails(selectedItem.ArtistUserName)" />

                        <!-- Details Section -->
                        <div class="flex-grow-1">
                            <!-- Artist Name -->
                            <a href="javascript:void(0);" class="fs-3 fw-semibold cursor-pointer d-block"
                                (click)="viewArtistDetails(selectedItem.ArtistUserName)">
                                {{ selectedItem.ArtistName }}
                            </a>
                            <!-- Business Name with Muted Color -->
                            <div *ngIf="selectedItem.BusinessName" class="fs-6 text-muted d-block mt-1">
                                {{ 'viewArtwork.tradingAs' | transloco }} <span class="fw-semibold">{{ selectedItem.BusinessName }}</span>
                            </div>
                            <!-- <div class="fs-6 text-muted d-block mt-1 fst-italic" *ngIf="selectedItem.AboutMe" [innerHTML]="selectedItem.AboutMe | safeHtml">
                            </div> -->

                        </div>
                    </div>

                    <div class="p-2 mt-2 bg-white rounded shadow-sm border border-light">
                        <div class="d-flex flex-column  mb-3 p-3 bg-light rounded shadow-sm border border-light">
                            <div class="flex-grow-1 d-flex justify-content-between align-items-center">
                                <!-- Name and Serial Number -->
                                <div>
                                    <span class="fw-semibold fs-4 text-dark">{{ selectedItem.Name }}</span>
                                    <span class="text-muted small ms-2" *ngIf="selectedItem.SerialNumber">
                                        ({{ selectedItem.SerialNumber }})
                                    </span>
                                </div>

                                <!-- Social Media Logos -->
                                <div class="d-flex align-items-center ms-3">
                                    <!-- SquareUp -->
                                    <div class="text-end me-2" *ngIf="selectedItem.SquarePosProductId">
                                        <!-- Show clickable logo only if product is not sold and user is logged in -->
                                        <ng-container *ngIf="!isProductSold && isAuthenticated; else disabledSquare">
                                            <a [href]="selectedItem.SquarePosStoreUrl" target="_blank"
                                                class="cursor-pointer d-flex flex-column align-items-center"
                                                [title]="'viewArtwork.postedToSquareUp' | transloco">
                                                <img src="assets/images/square-log.png" alt="SquareUp Logo"
                                                    class="rounded-circle mb-2" style="height: 20px;">
                                            </a>
                                        </ng-container>
                                        <!-- Show faded logo if product is sold or user is not logged in -->
                                        <ng-template #disabledSquare>
                                            <img src="assets/images/square-log.png" alt="SquareUp Logo"
                                                class="rounded-circle mb-2" style="height: 20px; opacity: 0.5;">
                                        </ng-template>
                                    </div>

                                    <!-- Shopify -->
                                    <div class="text-end me-2" *ngIf="shopifyStores.length > 0">
                                        <ng-container *ngIf="!isProductSold && isAuthenticated; else disabledShopify">
                                            <!-- Clickable image for active product and logged-in user -->
                                            <div class="cursor-pointer d-flex flex-column align-items-center"
                                                [title]="'viewArtwork.postedToShopify' | transloco"
                                                (click)="openShopifyLinksDialog()">
                                                <img src="assets/images/shopify-log.png" alt="Shopify Logo"
                                                    class="rounded-circle mb-2" style="height: 20px;">
                                            </div>
                                        </ng-container>
                                        <ng-template #disabledShopify>
                                            <!-- Faded image if product is sold or user not logged in -->
                                            <img src="assets/images/shopify-log.png" alt="Shopify Logo"
                                                class="rounded-circle mb-2" style="height: 20px; opacity: 0.5;">
                                        </ng-template>
                                    </div>

                                    <!-- WooCommerce -->
                                    <div class="text-end me-2" *ngIf="wooCommerceStores.length > 0">
                                        <ng-container *ngIf="!isProductSold && isAuthenticated; else disabledWoo">
                                            <div class="cursor-pointer d-flex flex-column align-items-center"
                                                [title]="'viewArtwork.postedToWooCommerce' | transloco"
                                                (click)="openWooCommerceLinksDialog()">
                                                <img src="assets/images/woocommerace-log.png" alt="WooCommerce Logo"
                                                    class="rounded-circle mb-2" style="height: 20px;">
                                            </div>
                                        </ng-container>
                                        <ng-template #disabledWoo>
                                            <img src="assets/images/woocommerace-log.png" alt="WooCommerce Logo"
                                                class="rounded-circle mb-2" style="height: 20px; opacity: 0.5;">
                                        </ng-template>
                                    </div>

                                    <!-- SquareSpace -->
                                    <div class="text-end" *ngIf="squareSpaceStores.length > 0">
                                        <ng-container
                                            *ngIf="!isProductSold && isAuthenticated; else disabledSquareSpace">
                                            <div class="cursor-pointer d-flex flex-column align-items-center"
                                                [title]="'viewArtwork.postedToSquareSpace' | transloco"
                                                (click)="openSquareSpaceLinksDialog()">
                                                <img src="assets/images/squarespace.svg" alt="SquareSpace Logo"
                                                    class="rounded-circle mb-2" style="height: 20px;">
                                            </div>
                                        </ng-container>
                                        <ng-template #disabledSquareSpace>
                                            <img src="assets/images/squarespace.svg" alt="SquareSpace Logo"
                                                class="rounded-circle mb-2" style="height: 20px; opacity: 0.5;">
                                        </ng-template>
                                    </div>

                                    <!-- Wix -->
                                    <div class="text-end" *ngIf="selectedItem.WixProductId">
                                        <ng-container *ngIf="!isProductSold && isAuthenticated; else disabledWix">
                                            <a [href]="selectedItem.WixProductLink" target="_blank"
                                                class="cursor-pointer d-flex flex-column align-items-center"
                                                [title]="'viewArtwork.postedToWix' | transloco">
                                                <img src="assets/images/wix-logo.png" alt="Wix Logo"
                                                    class="rounded-circle mb-2 ms-2" style="height: 20px;">
                                            </a>
                                        </ng-container>
                                        <ng-template #disabledWix>
                                            <img src="assets/images/wix-logo.png" alt="Wix Logo"
                                                class="rounded-circle mb-2 ms-2" style="height: 20px; opacity: 0.5;">
                                        </ng-template>
                                    </div>


                                    <!-- Shopify Links Dialog -->
                                    <p-dialog [header]="'viewArtwork.shopifyLinks' | transloco: { count: shopifyStores.length }"
                                        [(visible)]="shopifyLinksDialogVisible" [style]="{ width: '30rem' }"
                                        [modal]="true">
                                        <div class="mb-3 text-muted" style="font-size: 0.95rem;">
                                            {{ 'viewArtwork.shopifySyncedWith' | transloco: { count: shopifyStores.length, plural: (shopifyStores.length > 1 ? 's' : '') } }}
                                            <br>
                                            {{ 'viewArtwork.shopifyClickLink' | transloco }}
                                        </div>
                                        <ul *ngIf="shopifyStores.length > 0" class="list-unstyled">
                                            <li *ngFor="let item of shopifyStores; let i = index" class="mb-2">
                                                <a [href]="item.PlatformProductLink" target="_blank"
                                                    class="text-decoration-none">
                                                    🔗 {{ 'viewArtwork.storeLabel' | transloco: { number: i + 1, name: (item.ShopifyStoreDetailDTO?.StoreName || 'Unnamed Store') } }}
                                                </a>
                                            </li>
                                        </ul>
                                        <div *ngIf="shopifyStores.length === 0" class="text-danger text-center mt-4">
                                            {{ 'viewArtwork.noShopifyLinks' | transloco }}
                                        </div>
                                    </p-dialog>

                                    <!-- WooCommerce Links Dialog -->
                                    <p-dialog [header]="'viewArtwork.wooCommerceLinks' | transloco: { count: wooCommerceStores.length }"
                                        [(visible)]="wooCommerceLinksDialogVisible" [style]="{ width: '30rem' }"
                                        [modal]="true">
                                        <div class="mb-3 text-muted" style="font-size: 0.95rem;">
                                            {{ 'viewArtwork.wooCommerceSyncedWith' | transloco: { count: wooCommerceStores.length, plural: (wooCommerceStores.length > 1 ? 's' : '') } }}
                                            <br>
                                            {{ 'viewArtwork.wooCommerceClickLink' | transloco }}
                                        </div>
                                        <ul *ngIf="wooCommerceStores.length > 0" class="list-unstyled">
                                            <li *ngFor="let item of wooCommerceStores; let i = index" class="mb-2">
                                                <a [href]="item.PlatformProductLink" target="_blank"
                                                    class="text-decoration-none">
                                                    🔗 {{ 'viewArtwork.storeLabel' | transloco: { number: i + 1, name: (item.WooCommerceStoreDetail?.StoreName || 'Unnamed Store') } }}
                                                </a>
                                            </li>
                                        </ul>
                                        <div *ngIf="wooCommerceStores.length === 0"
                                            class="text-danger text-center mt-4">
                                            {{ 'viewArtwork.noWooCommerceLinks' | transloco }}
                                        </div>
                                    </p-dialog>

                                    <!-- SquareSpace Links Dialog -->
                                    <p-dialog [header]="'viewArtwork.squareSpaceLinks' | transloco: { count: squareSpaceStores.length }"
                                        [style]="{ width: '30rem' }" [modal]="true"
                                        [(visible)]="squareSpaceLinksDialogVisible">
                                        <div class="mb-3 text-muted" style="font-size: 0.95rem;">
                                            {{ 'viewArtwork.squareSpaceSyncedWith' | transloco: { count: squareSpaceStores.length, plural: (squareSpaceStores.length > 1 ? 's' : '') } }}
                                            <br>
                                            {{ 'viewArtwork.squareSpaceClickLink' | transloco }}
                                        </div>
                                        <ul *ngIf="squareSpaceStores.length > 0" class="list-unstyled">
                                            <li *ngFor="let item of squareSpaceStores; let i = index" class="mb-2">
                                                <a [href]="item.PlatformProductLink" target="_blank"
                                                    class="text-decoration-none">
                                                    🔗 {{ 'viewArtwork.pageLabel' | transloco: { number: i + 1, name: (item.SquareSpaceSitesDetailDto?.SiteInfo?.title || 'Unnamed Page') } }}
                                                </a>
                                            </li>
                                        </ul>
                                        <div *ngIf="squareSpaceStores.length === 0"
                                            class="text-danger text-center mt-4">
                                            {{ 'viewArtwork.noSquareSpaceLinks' | transloco }}
                                        </div>
                                    </p-dialog>

                                </div>

                            </div>

                            <div class="position-relative cursor-pointer mb-3 mt-4  d-block d-md-none">

                                <img [src]="selectedItem.ProductImgUrl ? selectedItem.ProductImgUrl : 'assets/images/No-Image.png'"
                                    class="w-100" (click)="toggleFullScreenImage()" />

                                <div class="detail-item position-absolute" *ngIf="productStatus"
                                    style="top: 15px; right: 15px; z-index: 1;">
                                    <span class="badge bg-danger" style="font-size: 1rem;">{{ productStatus }}</span>
                                </div>
                                <div class="detail-item position-absolute" style="bottom: 0; left: 15px; z-index: 1;">
                                    <span class="badge bg-secondary me-2" style="font-size: 0.9rem;"
                                        *ngIf="selectedItem.Length">{{ 'viewArtwork.lengthCm' | transloco: { value: selectedItem.Length } }}</span>
                                    <span class="badge bg-secondary me-2" style="font-size: 0.9rem;"
                                        *ngIf="selectedItem.Width">{{ 'viewArtwork.widthCm' | transloco: { value: selectedItem.Width } }}</span>
                                    <span class="badge bg-secondary me-2" style="font-size: 0.9rem;"
                                        *ngIf="selectedItem.Height">{{ 'viewArtwork.heightCm' | transloco: { value: selectedItem.Height } }}</span>
                                    <span class="badge bg-secondary me-2" style="font-size: 0.9rem;"
                                        *ngIf="selectedItem.Weight">{{ 'viewArtwork.weightKg' | transloco: { value: selectedItem.Weight } }}</span>
                                </div>
                            </div>

                        </div>

                        <!-- Short Description -->
                        <ng-container *ngIf="selectedItem.ShortDescription">
                            <div class="fw-bold mt-2 text-white p-2 rounded section-header">{{ 'viewArtwork.shortDescription' | transloco }}</div>
                            <div class="detail-item mb-3 text-gray-600 p-1 mt-2">
                                {{ selectedItem.ShortDescription }}
                            </div>
                        </ng-container>

                        <!-- Marketing Description -->
                        <ng-container *ngIf="selectedItem.LongDescription">
                            <div class="fw-bold mt-2 text-white p-2 rounded section-header">{{ 'viewArtwork.marketingDescription' | transloco }}</div>
                            <div class="detail-item mb-3 text-gray-600 p-1 mt-2">{{ selectedItem.LongDescription }}
                            </div>
                        </ng-container>
                        <!-- Social Media Post -->
                        <ng-container *ngIf="selectedItem.SocialMediaDescription">
                            <div class="fw-bold mt-2 text-white p-2 rounded section-header">{{ 'viewArtwork.socialMediaPost' | transloco }}</div>
                            <div class="detail-item mb-3 text-gray-600 mt-2 p-1">
                                {{ selectedItem.SocialMediaDescription }}
                            </div>
                        </ng-container>
                        <div *ngIf="selectedItem && (selectedItem.ArtTypeName || selectedItem.CategoryName || selectedItem.SeriesName || selectedItem.MaterialName || (selectedItem.SelectedGlazes && selectedItem.SelectedGlazes.length > 0))"
                            class="mt-4">
                            <div class="fw-bold mt-2 text-white p-2 rounded section-header">
                                {{ 'viewArtwork.artworkInformation' | transloco }}
                            </div>
                            <div class="row p-1">
                                <div class="detail-item mb-2 mt-3" *ngIf="selectedItem.ArtTypeName">
                                    <span class="fw-semibold">{{ 'viewArtwork.artTypeLabel' | transloco }}</span>
                                    <span class="text-sceondary">{{ selectedItem.ArtTypeName }}</span>
                                    <i class="fa fa-info-circle  ms-1 cursor-pointer"
                                        pTooltip="{{selectedItem.ArtTypeDescription}}"
                                        *ngIf="selectedItem.ArtTypeDescription"></i>
                                </div>

                                <div class="detail-item mb-2" *ngIf="selectedItem.CategoryName">
                                    <span class="fw-semibold ">{{ 'viewArtwork.categoryLabel' | transloco }}</span>
                                    <span class="text-sceondary">{{ selectedItem.CategoryName }}</span>
                                    <i class="fa fa-info-circle ms-1 cursor-pointer"
                                        pTooltip="{{selectedItem.CategoryDescription}}"
                                        *ngIf="selectedItem.CategoryDescription"></i>
                                </div>

                                <div class="detail-item mb-2" *ngIf="selectedItem.SeriesName">
                                    <span class="fw-semibold">{{ 'viewArtwork.seriesLabel' | transloco }}</span>
                                    <span class="text-sceondary">{{ selectedItem.SeriesName }}</span>
                                    <i class="fa fa-info-circle ms-1 cursor-pointer"
                                        pTooltip="{{selectedItem.SeriesDescription}}"
                                        *ngIf="selectedItem.SeriesDescription"></i>
                                </div>

                                <div class="detail-item mb-2" *ngIf="selectedItem.MaterialName">
                                    <span class="fw-semibold">{{ 'viewArtwork.materialLabel' | transloco }}</span>
                                    <span class="text-sceondary">{{ selectedItem.MaterialName }}</span>
                                    <i class="fa fa-info-circle ms-1 cursor-pointer"
                                        pTooltip="{{selectedItem.MaterialDescription}}"
                                        *ngIf="selectedItem.MaterialDescription"></i>
                                </div>

                                <div class="detail-item mb-2"
                                    *ngIf="selectedItem.SelectedGlazes && selectedItem.SelectedGlazes.length > 0">
                                    <span class="fw-semibold">{{ 'viewArtwork.featuresLabel' | transloco }}</span>
                                    <span *ngFor="let glaze of selectedItem.SelectedGlazes"
                                        class="badge bg-secondary  ms-2" pTooltip="{{glaze.GlazeDescription}}"
                                        tooltipPosition="bottom">
                                        {{ glaze.GlazeName }}
                                        <ng-container *ngIf="glaze.GlazeDescription">
                                            <i class="fa fa-info-circle text-sceondary  ms-1 cursor-pointer"></i>
                                        </ng-container>
                                    </span>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!-- Descriptions -->
                    <div class="p-2 mt-2 bg-white rounded shadow-sm border border-light"
                        *ngIf="isAuthenticated && authConfig.IsGallery && selectedItem.IsGalleryProduct">
                        <div class="fw-bold mt-2 text-white p-2 rounded mb-3 section-header">
                            {{ 'viewArtwork.generateAiDescriptions' | transloco }}
                        </div>
                        <div class="mb-2">
                            <!-- Short Description Section -->
                            <div class="d-flex align-items-center justify-content-between mb-2">
                                <div class="fw-bold text-dark">{{ 'viewArtwork.yourShortDescription' | transloco }}</div>
                                <button pButton type="button" icon="fa fa-android" [label]="'viewArtwork.generateDescription' | transloco"
                                    class="p-button-sm p-button-primary p-button-outlined"
                                    (click)="showChatGPTDialog($event)" [disabled]="isProductSold">
                                </button>
                            </div>
                            <textarea class="form-control border-light"
                                [(ngModel)]="galleryDescription.GalleryShortDescription" rows="6" cols="6"
                                [disabled]="isProductSold" [placeholder]="'viewArtwork.enterBriefDescription' | transloco"></textarea>
                        </div>

                        <div class="mb-2">
                            <!-- Long Description Section -->
                            <div class="d-flex align-items-center mb-2">
                                <div class="fw-bold text-dark">{{ 'viewArtwork.yourMarketingDescription' | transloco }}</div>
                            </div>
                            <textarea class="form-control border-light"
                                [(ngModel)]="galleryDescription.GalleryLongDescription" rows="8" cols="8"
                                [disabled]="isProductSold" [placeholder]="'viewArtwork.describeArtworkDetail' | transloco"></textarea>
                        </div>

                        <div class="mb-2">
                            <!-- Social Media Post Section -->
                            <div class="d-flex align-items-center">
                                <span class="fw-bold text-dark mb-2">{{ 'viewArtwork.yourSocialMediaPost' | transloco }}</span>
                            </div>
                            <textarea class="form-control border-light"
                                [(ngModel)]="galleryDescription.GallerySocialMediaDescription" rows="6" cols="6"
                                [disabled]="isProductSold"
                                [placeholder]="'viewArtwork.createEngagingPost' | transloco"></textarea>
                        </div>
                    </div>
                </div>

                <div class="col-5 px-0">
                    <div class="position-relative cursor-pointer mb-3 d-none d-md-block">

                        <img [src]="selectedItem.ProductImgUrl ? selectedItem.ProductImgUrl : 'assets/images/No-Image.png'"
                            class="w-100" (click)="toggleFullScreenImage()" />

                        <div class="detail-item position-absolute" *ngIf="productStatus"
                            style="top: 15px; right: 15px; z-index: 1;">
                            <span class="badge bg-danger" style="font-size: 1rem;">{{ productStatus }}</span>
                        </div>
                        <div class="detail-item position-absolute" style="bottom: 0; left: 15px; z-index: 1;">
                            <span class="badge bg-secondary me-2" style="font-size: 0.9rem;"
                                *ngIf="selectedItem.Length">{{ 'viewArtwork.lengthCm' | transloco: { value: selectedItem.Length } }}</span>
                            <span class="badge bg-secondary me-2" style="font-size: 0.9rem;"
                                *ngIf="selectedItem.Width">{{ 'viewArtwork.widthCm' | transloco: { value: selectedItem.Width } }}</span>
                            <span class="badge bg-secondary me-2" style="font-size: 0.9rem;"
                                *ngIf="selectedItem.Height">{{ 'viewArtwork.heightCm' | transloco: { value: selectedItem.Height } }}</span>
                            <span class="badge bg-secondary me-2" style="font-size: 0.9rem;"
                                *ngIf="selectedItem.Weight">{{ 'viewArtwork.weightKg' | transloco: { value: selectedItem.Weight } }}</span>
                        </div>
                    </div>
                    <p-dialog [showHeader]="false" [modal]="true" [(visible)]="showFullScreenImage" [resizable]="false"
                        [draggable]="false" styleClass="dialogcontent-without-padding" [style]="{ width: '660px' }">
                        <div class="position-relative w-100 " style="overflow: hidden;">
                            <img [src]="selectedItem.ProductImgUrl ? selectedItem.ProductImgUrl : 'assets/images/No-Image.png'"
                                class="w-100 h-100" style="object-fit: contain;" />
                            <!-- Close button -->
                            <div class="position-absolute cursor-pointer" style="top: 10px; right: 10px;">
                                <i class="fa fa-times-circle fs-1 fw-bolder" (click)="closeFullScreenImage()"></i>
                            </div>
                        </div>
                    </p-dialog>
                    <!-- Additional Images using p-galleria -->
                    <div
                        *ngIf="galleria && selectedItem.ArtistProductImages && selectedItem.ArtistProductImages.length > 1">
                        <div class="card"
                            style="margin-top: 10px; border: 1px solid #ccc; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); box-sizing: border-box;">
                            <!-- Image outside of p-galleria -->
                            <p-galleria [value]="selectedItem.ArtistProductImages" [activeIndex]="activeIndex">
                                <ng-template pTemplate="thumbnail" let-item>
                                    <div class="grid grid-nogutter" (click)="onThumbnailClick(item)">
                                        <img [src]="item" [alt]="'viewArtwork.thumbnail' | transloco"
                                            style="width: 40px; height: 40px; cursor: pointer;" />
                                    </div>
                                </ng-template>
                            </p-galleria>
                        </div>
                    </div>
                    <div *ngIf="selectedItem.IsGalleryProduct || selectedItem.IsArtistOwnProduct || authConfig.IsSuperAdmin"
                        class="p-2 rounded shadow-sm">
                        <div class="form-group my-2">
                            <p-panel [header]="'viewArtwork.onlyVisibleToYou' | transloco" [toggleable]="false">
                                <ng-template pTemplate="icons">
                                    <ng-container *ngIf="selectedItem.IsGalleryProduct && !isProductSold">
                                        <button type="button" pButton icon="fa fa-save" [label]="'viewArtwork.saveChanges' | transloco"
                                            (click)="SaveDetail()" class="ms-2 p-button-outlined"
                                            [disabled]="!consignedProduct.SuggestedSalePrice"></button>
                                    </ng-container>
                                </ng-template>

                                <!-- Consignment History Section -->
                                <div class="mb-2 ">
                                    <!-- Section Title -->
                                    <div class="fw-bold mt-2 text-white p-2 rounded section-header mb-2 ">
                                        {{ 'viewArtwork.consignmentHistory' | transloco }}
                                    </div>

                                    <!-- Consignment Details -->
                                    <div class="d-flex flex-column mt-2">
                                        <div class="d-flex align-items-center">
                                            <span>{{ 'viewArtwork.dispatchedBy' | transloco }}</span>
                                            <span class="ms-2">{{ selectedItem.ArtistName }}</span>
                                        </div>
                                        <div class="d-flex align-items-center">
                                            <span>{{ 'viewArtwork.dispatchDate' | transloco }}</span>
                                            <span class="ms-2">{{ selectedItem.ConsignmentDispatchedDate | date:
                                                'dd/MM/yyyy HH:mm' }}</span>
                                        </div>
                                        <div class="d-flex align-items-center">
                                            <span>{{ 'viewArtwork.acceptedByGallery' | transloco }}</span>
                                            <span class="ms-2">{{ selectedItem.GalleryAcceptedDate | date:
                                                'dd/MM/yyyy/HH:mm' }}</span>
                                        </div>
                                    </div>

                                    <!-- Additional Information: Sold Details -->
                                    <ng-container *ngIf="isProductSold">
                                        <div class="mt-2">
                                            <div class="fw-bold mt-2 text-white p-2 rounded section-header mb-2">
                                                {{ 'viewArtwork.soldDetails' | transloco }}
                                            </div>
                                            <div class="row mt-2">
                                                <!-- Sold on Date -->
                                                <div class="col-12 col-sm-6">
                                                    <div class="d-flex align-items-center">
                                                        <span>{{ 'viewArtwork.soldOn' | transloco }}</span>
                                                        <span class="ms-1">{{ selectedItem.SoldDate | date:
                                                            'dd/MM/yyyy/HH:mm' }}</span>
                                                    </div>
                                                </div>
                                                <!-- Sold Price -->
                                                <div class="col-12 col-sm-6">
                                                    <div class="d-flex align-items-center">
                                                        <span>{{ 'viewArtwork.soldPrice' | transloco }}</span>
                                                        <span class="ms-1">{{ selectedItem.SoldPrice | currency: 'USD' :
                                                            'symbol' : '1.2-2' }}</span>
                                                    </div>
                                                </div>
                                                <!-- Platform -->
                                                <div class="col-12 col-sm-6">
                                                    <div class="d-flex align-items-center">
                                                        <span>{{ 'viewArtwork.platform' | transloco }}</span>
                                                        <span class="ms-1">{{ selectedItem.SoldOnPlateform }}</span>
                                                    </div>
                                                </div>
                                                <!-- Target Platform Price -->
                                                <div class="col-12 col-sm-6"
                                                    *ngIf="selectedItem?.SoldOnPlateform?.toLowerCase() !== 'artflow'">
                                                    <div class="d-flex align-items-center">
                                                        <span>{{ 'viewArtwork.targetPlatformSoldPrice' | transloco }}</span>
                                                        <span class="ms-1">
                                                            {{ selectedItem.TargetPlateFormSoldPrice |
                                                            currency:selectedItem.TargertPlateFormSoldProductCurrencySymbol:'symbol':'1.2-2'
                                                            }}
                                                        </span>
                                                    </div>
                                                </div>
                                                <!-- Turnover Rate -->
                                                <div class="col-12 col-sm-6"
                                                    *ngIf="selectedItem.ProductTurnoverRateDays">
                                                    <div class="d-flex align-items-center">
                                                        <span>{{ 'viewArtwork.turnoverRate' | transloco }}</span>
                                                        <span class="ms-1">{{ 'viewArtwork.daysCount' | transloco: { count: (selectedItem.ProductTurnoverRateDays | number) } }}</span>
                                                    </div>
                                                </div>
                                                <!-- Exchange Rate -->
                                                <div class="col-12 col-sm-6"
                                                    *ngIf="selectedItem?.SoldOnPlateform?.toLowerCase() !== 'artflow'">
                                                    <div class="d-flex align-items-center">
                                                        <span>{{ 'viewArtwork.exchangeRate' | transloco }}</span>
                                                        <span class="ms-1">{{ selectedItem.ExchangeRateOnSoldProduct
                                                            }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>

                                </div>

                                <!-- Editable Fields Section -->
                                <ng-container *ngIf="selectedItem.IsGalleryProduct && !isProductSold">
                                    <p class="text-muted mb-3">{{ 'viewArtwork.editSalePriceHelp' | transloco }}</p>
                                    <form #resetForm="ngForm">
                                        <div class="mb-3">
                                            <label class="mb-2" for="retailPrice">{{ 'viewArtwork.retailPrice' | transloco }}</label>
                                            <input type="number" id="retailPrice" class="form-control"
                                                name="retailPrice" disabled [value]="selectedItem.RetailPrice" />
                                        </div>
                                        <div class="mb-3">
                                            <label class="mb-2" for="SuggestedSalePrice">{{ 'viewArtwork.suggestedSalePrice' | transloco }}</label>
                                            <input type="number" id="SuggestedSalePrice" class="form-control"
                                                [(ngModel)]="consignedProduct.SuggestedSalePrice" min="0"
                                                name="SuggestedSalePrice" [placeholder]="'viewArtwork.enterSuggestedSalePrice' | transloco"
                                                (input)="preventNegativeValues($event)" />
                                        </div>
                                        <div class="mb-3">
                                            <label class="mb-2" for="Remarks">{{ 'viewArtwork.remarks' | transloco }}</label>
                                            <textarea id="Remarks" name="Remarks" rows="16" cols="16"
                                                class="form-control" [(ngModel)]="consignedProduct.Remarks"
                                                [placeholder]="'viewArtwork.addRemarksHere' | transloco"></textarea>
                                        </div>
                                    </form>
                                    <div class="mt-3">
                                        <p class="text-muted">{{ 'viewArtwork.onceMadeChanges' | transloco }} <strong>{{ 'viewArtwork.saveChanges' | transloco }}</strong> {{ 'viewArtwork.toUpdateDetails' | transloco }}</p>
                                    </div>
                                </ng-container>
                            </p-panel>
                        </div>
                    </div>
                    <p-sidebar [(visible)]="sidebarActivityLogsVisible" position="right" [style]="{'width': '360px'}"
                        [modal]="false" [closeOnEscape]="true" [showCloseIcon]="true" styleClass="custom-sidebar">
                        <p-tabView [(activeIndex)]="selectedTabIndex"
                            *ngIf="isAuthenticated &&  isTabsVisible && (isProductAvailable || isProductSold || selectedItem?.IsGalleryProduct || selectedItem?.IsArtistOwnProduct)">
                            <p-tabPanel [header]="'viewArtwork.productActivity' | transloco">
                                <div class="form-group mt-5 mb-2">
                                    <div *ngIf="selectedItem.ArtistProductLogs && selectedItem.ArtistProductLogs.length > 0">
                                        <p-timeline [value]="selectedItem.ArtistProductLogs">
                                            <ng-template pTemplate="content" let-event>
                                                <small class="p-text-secondary">{{ event.ActionDate |
                                                    date:'dd/MM/yyyy/HH:mm'}}</small>
                                            </ng-template>
                                            <ng-template pTemplate="opposite" let-event>
                                                {{ event.Message }}
                                            </ng-template>
                                        </p-timeline>
                                    </div>
                                    <div *ngIf="!selectedItem.ArtistProductLogs || selectedItem.ArtistProductLogs.length === 0"
                                        class="d-flex justify-content-center align-items-center" style="min-height: 200px;">
                                        <span class="text-muted">{{ 'viewArtwork.noActivityLogs' | transloco }}</span>
                                    </div>
                                </div>

                            </p-tabPanel>
                            <p-tabPanel [header]="'viewArtwork.marketingActivity' | transloco">
                                <!-- <ng-template pTemplate="icons" *ngIf="isProductAvailable || !isProductSold">
                                  <button pButton class="d-flex align-items-center justify-content-center mt-3 w-100" [style.backgroundColor]="'#178d9b'" [style.color]="'white'" 
                                      (click)="onOpenSocialPostDailog()">New Social Post
                                  </button>
                                </ng-template> -->
                                <div *ngIf="socialPosts.length == 0" class="d-flex justify-content-center">
                                    <span>{{ 'viewArtwork.noSocialPostFound' | transloco }}</span>
                                </div>
                                <ng-container *ngIf="socialPosts && socialPosts.length > 0;">
                                    <p-accordion [activeIndex]="0">
                                        <p-accordionTab *ngFor="let post of socialPosts; let i = index"
                                            [header]="'viewArtwork.viewYourSocialMediaPosts' | transloco: { number: i + 1 }">
                                            <div class="social-post rounded mb-3 p-3 shadow-lg">
                                                <div class="d-flex justify-content-center">
                                                    <img [src]="post.ImageURL || 'assets/images/No-Image.png'" alt="pic"
                                                        class="rounded-cube centered-image me-3 mb-4" width="30"
                                                        height="30">
                                                </div>
                                                <div class="d-flex justify-content-center align-items-center mb-3">
                                                    <div class="">
                                                        <div class="fw-bold fs-5 text-center mb-2">{{ post.HeadLine }}
                                                        </div>
                                                        <div class="text-muted text-center fs-6 mb-2">{{
                                                            post.Description }}</div>
                                                    </div>
                                                </div>
                                                <!-- <div class="d-flex align-items-center mb-3">
                                          <img [src]="post.ImageURL || 'assets/images/No-Image.png'" alt="pic" 
                                              class="rounded-circle me-3" width="30" height="30">
                                          <div class="text-truncate">
                                            <div class="fw-bold fs-5">{{ post.HeadLine }}</div>
                                            <div class="text-muted text-truncate fs-6">{{ post.Description }}</div>
                                          </div>
                                        </div> -->

                                                <div class="d-flex justify-content-between mb-3 text-muted">
                                                    <ng-container *ngIf="post.PostedOn === 'Facebook'">
                                                        <div class="d-flex align-items-center mb-2">
                                                            <img [src]="post.FacebookAccount.FacebookProfilePicture || 'assets/images/No-Image.png'"
                                                                class="rounded-circle social-media-logo me-2" alt="pic"
                                                                width="30" height="30">
                                                            <span class="fw-bold">{{
                                                                post.FacebookAccount.FacebookProfileName }}</span>
                                                        </div>
                                                    </ng-container>

                                                    <ng-container *ngIf="post.PostedOn === 'Facebook'">
                                                        <div class="d-flex">
                                                            <img [src]="post.FacebookAccount.FacebookPagePicture ? post.FacebookAccount.FacebookPagePicture : 'assets/images/No-Image.png'"
                                                                class="rounded-circle social-media-logo me-2" alt="pic"
                                                                width="40" height="40">
                                                            <span
                                                                class="text-truncate fw-bold">{{post.FacebookAccount.FacebookPageName
                                                                }}</span>
                                                        </div>
                                                    </ng-container>

                                                    <ng-container *ngIf="post.PostedOn === 'Instagram'">
                                                        <div class="d-flex align-items-center mb-2">
                                                            <img [src]="post.InstagramAccount.InstagramPagePicture || 'assets/images/No-Image.png'"
                                                                class="rounded-circle  social-media-logo me-2" alt="pic"
                                                                width="30" height="30">
                                                            <span class="fw-bold">{{
                                                                post.InstagramAccount.InstagramPageName }}</span>
                                                        </div>
                                                    </ng-container>

                                                    <div class="d-flex align-items-center justify-content-between">
                                                        {{ post.CreatedDate | date: 'dd/MM/yyyy HH:mm' }}
                                                    </div>
                                                </div>

                                                <!-- Activity Stats -->
                                                <div *ngIf="post.FacebookAccount?.PageIsActive || post.InstagramAccount?.PageIsActive"
                                                    class="stats bg-light p-3 rounded">
                                                    <ng-container *ngIf="post.PostedOn === 'Facebook'">
                                                        <ng-container
                                                            *ngIf="post.SocialMediaInsights.TotalLikes > 0 || post.SocialMediaInsights.TotalComments > 0; else noActivityMessage">
                                                            <div
                                                                class="d-flex justify-content-between align-items-center">
                                                                <div class="d-flex align-items-center">
                                                                    <img src="assets/images/social/facebook.png"
                                                                        class="rounded-circle social-media-logo me-2"
                                                                        width="15" height="15">
                                                                    <span class="fs-6">{{ 'viewArtwork.likesCount' | transloco: { count: post.SocialMediaInsights.TotalLikes } }}</span>
                                                                </div>
                                                                <span class="fs-6">{{ 'viewArtwork.commentsCount' | transloco: { count: post.SocialMediaInsights.TotalComments } }}</span>
                                                                <span class="fs-6">{{ 'viewArtwork.sharesCount' | transloco: { count: post.SocialMediaInsights.TotalShares } }}</span>
                                                            </div>
                                                        </ng-container>
                                                        <ng-template #noActivityMessage>
                                                            <div class="d-flex justify-content-center">
                                                                <img src="assets/images/social/facebook.png"
                                                                    class="rounded-circle social-media-logo me-1"
                                                                    width="15" height="15">
                                                                <span>{{ 'viewArtwork.noActivityFound' | transloco }}</span>
                                                            </div>
                                                        </ng-template>
                                                    </ng-container>

                                                    <ng-container *ngIf="post.PostedOn === 'Instagram'">
                                                        <ng-container
                                                            *ngIf="post.SocialMediaInsights.TotalLikes > 0 || post.SocialMediaInsights.TotalComments > 0; else noActivityMessage">
                                                            <div
                                                                class="d-flex justify-content-between align-items-center">
                                                                <div class="d-flex align-items-center">
                                                                    <img src="assets/images/social/instagram.png"
                                                                        class="rounded-circle social-media-logo me-2"
                                                                        width="20" height="20">
                                                                    <span class="fs-6">{{ 'viewArtwork.likesCount' | transloco: { count: post.SocialMediaInsights.TotalLikes } }}</span>
                                                                </div>
                                                                <span class="fs-6">{{ 'viewArtwork.commentsCount' | transloco: { count: post.SocialMediaInsights.TotalComments } }}</span>
                                                            </div>
                                                        </ng-container>
                                                        <ng-template #noActivityMessage>
                                                            <div class="d-flex justify-content-center">
                                                                <img src="assets/images/social/instagram.png"
                                                                    class="rounded-circle social-media-logo me-1"
                                                                    width="15" height="15">
                                                                <span>{{ 'viewArtwork.noActivityFound' | transloco }}</span>
                                                            </div>
                                                        </ng-template>
                                                    </ng-container>
                                                </div>

                                                <!-- Deactivated Account Message -->
                                                <div *ngIf="!post.FacebookAccount?.PageIsActive && post.PostedOn === 'Facebook'"
                                                    class="bg-warning d-flex justify-content-center text-center p-3 rounded">
                                                    <!-- <ng-container *ngIf=""> -->
                                                    <img src="assets/images/social/facebook.png"
                                                        class="rounded-pill social-media-logo me-1" width="40"
                                                        height="40">
                                                    {{ 'viewArtwork.facebookAccountDeactivated' | transloco }}
                                                    <!-- </ng-container> -->
                                                </div>
                                                <div *ngIf="!post.InstagramAccount?.PageIsActive && post.PostedOn === 'Instagram'"
                                                    class="bg-warning d-flex justify-content-center text-center p-3 rounded">
                                                    <!-- <ng-container *ngIf=""> -->
                                                    <img src="assets/images/social/instagram.png"
                                                        class="rounded-pill social-media-logo me-1" width="40"
                                                        height="40">
                                                    {{ 'viewArtwork.instagramAccountDeactivated' | transloco }}
                                                    <!-- </ng-container> -->
                                                </div>
                                            </div>
                                        </p-accordionTab>
                                    </p-accordion>
                                </ng-container>
                                <!-- <ng-template #noPostsMessage>
                                  <div class="text-center text-muted">No posts available.</div>
                                </ng-template> -->
                            </p-tabPanel>

                        </p-tabView>
                    </p-sidebar>
                </div>

                <div class="col-12  rounded my-4 " *ngIf="RelevantProducts.length > 0">
                    <div class="fw-semibold fs-4">{{ 'viewArtwork.relevantProducts' | transloco }}</div>
                    <div class="text-secondary text-small fst-italic">{{ 'viewArtwork.relevantProductsDescription' | transloco }}</div>
                    <!-- Compact Product Cards -->
                    <div class="row mt-4">
                        <div *ngFor="let product of RelevantProducts" class="col-4  col-lg-2 mt-3 mb-4">
                            <div class="card shadow-sm cursor-pointer h-100 rounded-3 text-center" (click)="showProductDetail(product)">
                                <!-- Product Image -->
                                <img [src]="product.ProductImgUrl ? product.ProductImgUrl : 'assets/images/No-Image.png'"
                                    class="card-img-top rounded-3 w-100 img-fluid mx-auto d-block" [alt]="'viewArtwork.productImage' | transloco">
                                <!-- Product Info -->
                                <div class="card-body p-1 mt-2">
                                    <div class="fw-semibold text-dark text-truncate fs-5" pTooltip="{{ product.Name }}"
                                        tooltipPosition="top">
                                        {{ product.Name }}
                                    </div>
                                    <div *ngIf="product.ArtistRevenue" class="text-muted mt-2">
                                        {{ 'viewArtwork.priceLabel' | transloco: { value: (product.ArtistRevenue | currency:'USD':'symbol':'1.2-2') } }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-container *ngIf="isProductSoldDialogVisible">
    <app-productsold [isProductSoldDialogVisible]="isProductSoldDialogVisible" [productSoldData]="productSoldData"
        (onCloseDailog)="onCloseProductSoldDailog($event)" (productSold)="onProductSold($event)"></app-productsold>
</ng-container>

<ng-container *ngIf="isProductShareDailogVisible">
    <product-share [isProductShareDailogVisible]="isProductShareDailogVisible" [artistId]="selectedItem.ArtistId"
        [artworkId]="selectedItem.Id" (onCloseDailog)="onCloseProductShareDailog($event)"></product-share>
</ng-container>

<!-- <ng-container *ngIf="isSocialPostDailogVisible">
    <create-social-post [isSocialPostDailogVisible]="isSocialPostDailogVisible" [selectedItem]="selectedItem"
        [galleryDescription]="galleryDescription"
        (getSocialPost)="getSocialPosts(selectedItem.Id)">
    </create-social-post>
</ng-container> -->
<p-dialog [header]="'viewArtwork.selectFacebookAccount' | transloco" [(visible)]="isFacebookPagesDailogVisible" [style]="{'width': '400px'}"
    [modal]="true" (onHide)="onCloseFacebookPostDailog()">
    <div class="text-center">
        <img src="assets/images/social post icons/facebook.png" alt="pic" width="25" height="25">
        <span class="ms-1">Facebook</span>
    </div>
    <form class="mt-3">
        <!-- <div *ngIf="facebookAccounts.length > 1">
            <label class="form-label"><span class="text-danger">*</span> Select Facebook Accounts</label>
            <p-dropdown [options]="facebookAccounts" [(ngModel)]="facebookAccountsId" placeholder="Select Account"
                [filter]="true" [filterBy]="'Name'" [optionLabel]="'Name'" [optionValue]="'Id'" name="FacebokAccounts"
                appendTo="body" [showClear]="true" (onChange)="onFacebookAccountSelection($event)">
            </p-dropdown>
        </div> -->
        <div>
            <div class="text-center mt-2" *ngIf="FacebookAccountImageUrl">
                <img src="{{FacebookAccountImageUrl}}" class="rounded-pill" width="90" height="auto">
            </div>
            <div class="text-center">
                <h2 *ngIf="FacebookAccountName">{{FacebookAccountName}}</h2>
            </div>
            <div class="text-center">
                <h6 *ngIf="FacebookAccountEmail">{{FacebookAccountEmail}}</h6>
            </div>
        </div>
        <div class="form-group">
            <label class="form-label"><span class="text-danger">*</span> {{ 'viewArtwork.selectFacebookPages' | transloco }}</label>
            <p-dropdown [options]="facebookPages" [(ngModel)]="selectedFacebookPage" [placeholder]="'viewArtwork.selectFacebookPage' | transloco"
                [filter]="true" [filterBy]="'PageName'" [optionLabel]="'PageName'" [optionValue]="'PageId'"
                name="FaceBookOuthPages" appendTo="body" (onChange)="onFacebookPageSelection($event)">
                <ng-template pTemplate="selectedItem" *ngIf="selectedFacebookPage">
                    <div class="d-flex align-items-center gap-2">
                        <img [src]="selectedFacebookPage.PagePicture" style="border-radius: 50%;" width="25" />
                        <div>{{selectedFacebookPage.PageName}}</div>
                    </div>
                    <div>{{ 'viewArtwork.selectPageToPost' | transloco }}</div>
                </ng-template>
                <ng-template let-rowData pTemplate="item">
                    <div class="d-flex justify-content-start align-items-center">
                        <img [src]="rowData.PagePicture ? rowData.PagePicture : 'assets/images/No-Image.png'"
                            style="border-radius: 50%;" width="25" />
                        <div class="ms-3">{{ rowData.PageName }}</div>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>
    </form>

    <div class="d-flex mt-3">
        <button class="btn btn-outline-primary btn-sm px-2 py-1 w-100" *ngIf="facebookPageId"
            (click)="postOnFacebook()">{{ 'viewArtwork.postOnFacebookPage' | transloco }}</button>
    </div>
</p-dialog>

<p-dialog [header]="'viewArtwork.selectInstagramAccounts' | transloco" [(visible)]="isInstagramPagesDailogVisible" [style]="{'width': '400px'}"
    [modal]="true" (onHide)="onCloseInstagramPostDailog()">
    <div class="text-center">
        <img src="assets/images/social post icons/instagram.png" alt="pic" width="25" height="25">
        <span class="ms-1">Instagram</span>
    </div>
    <form class="mt-3">
        <!-- <div *ngIf="instagramAccounts.length > 1">
            <label class="form-label"><span class="text-danger">*</span> Select Instagram Accounts</label>
            <p-dropdown [options]="instagramAccounts" [(ngModel)]="instagramAccountsId" placeholder="Select Account"
                [filter]="true" [filterBy]="'Name'" [optionLabel]="'Name'" [optionValue]="'Id'" name="InstagramAccounts"
                appendTo="body" [showClear]="true" (onChange)="onInstagramAccountSelection($event)">

            </p-dropdown>
        </div> -->
        <!-- <div *ngIf="selectedInstagramAccount">
            <div class="text-center mt-2">
                <img src="{{selectedInstagramAccount.ImageUrl}}" class="rounded-pill" width="90" height="auto">
            </div>
            <div class="text-center">
                <h2 class="fs-3">{{selectedInstagramAccount.Name}}</h2>
            </div>
            <div class="text-center">
                <h6>{{selectedInstagramAccount.Email}}</h6>
            </div>
        </div> -->
        <div class="form-group">
            <label class="form-label"><span class="text-danger">*</span> {{ 'viewArtwork.selectInstagramAccount' | transloco }}</label>
            <p-dropdown [options]="instagramAccounts" [(ngModel)]="selectedInstagramAccount"
                [placeholder]="'viewArtwork.selectAccount' | transloco" [filter]="true" [filterBy]="'UserName'" [optionLabel]="'UserName'"
                [optionValue]="'InstaUserId'" name="InstagramAccounts" appendTo="body"
                (onChange)="onInstagramAccountSelection($event)">
                <ng-template pTemplate="selectedItem" *ngIf="selectedInstagramAccount">
                    <div class="d-flex align-items-center gap-2">
                        <img [src]="selectedInstagramAccount.UserProfilePictureUrl" style="border-radius: 50%;"
                            width="25" />
                        <div>{{selectedInstagramAccount.UserName}}</div>
                    </div>
                    <div>{{ 'viewArtwork.selectPageToPost' | transloco }}</div>
                </ng-template>
                <ng-template let-rowData pTemplate="item">
                    <div class="d-flex justify-content-start align-items-center">
                        <img [src]="rowData.UserProfilePictureUrl ? rowData.UserProfilePictureUrl: 'assets/images/No-Image.png'"
                            style="border-radius: 50%;" width="25" />
                        <div class="ms-3">{{ rowData.UserName }}</div>
                    </div>
                </ng-template>
            </p-dropdown>

        </div>
    </form>
    <div class="d-flex mt-3">
        <button class="btn btn-outline-primary btn-sm px-2 py-1 w-100" *ngIf="instagramAccountsId"
            (click)="postOnInstagram()">{{ 'viewArtwork.postOnInstagramPage' | transloco }}</button>
    </div>
</p-dialog>

<p-dialog [header]="'viewArtwork.makeNewSocialMediaPost' | transloco" [(visible)]="isSocialPostDailogVisible" [style]="{'width': '40vw'}"
    [modal]="true">
    <div class="d-flex flex-row my-1">
        <div class="" *ngIf="isFacebook">
            <button type="button" class="btn p-1" (click)="onOpenFacebookUrl()">
                <img src="assets/images/social post icons/facebook.png" alt="pic" width="30" height="auto">
            </button>
        </div>
        <div class="" *ngIf="isInstagram">
            <button type="button" class="btn p-1" (click)="onOpenInstagramUrl()">
                <img src="assets/images/social post icons/instagram.png" alt="pic" width="30" height="auto">
            </button>
        </div>
    </div>

    <form class="mt-3" *ngIf="selectedItem">
        <h5 class="mt-3 ms-2">{{ 'viewArtwork.productImages' | transloco }}</h5>
        <div class="justify-content-start w-100 mt-2"
            *ngIf="selectedItem.IsGalleryProduct || selectedItem.IsArtistOwnProduct">
            <p-fileUpload #additionalFileUploadCmp name="files[]" [auto]="true" [customUpload]="false" accept="image/*"
                (onClear)="onAdditionalFileCleard($event)" (onSelect)="onFileSelected($event.files, true)"
                [multiple]="false" [previewWidth]="70" cancelStyleClass="ms-2">
                <ng-template pTemplate="toolbar">
                    <div class="mt-2">{{ 'viewArtwork.dragAndDropFiles' | transloco }}</div>
                </ng-template>
                <ng-template let-file pTemplate="file"></ng-template>
            </p-fileUpload>
        </div>


        <div class="text-center justify-content-center">
            <div class="product-share-image mb-1 mt-2 px-2">
                <img [src]="selectedItem.ProductImgUrl" [alt]="'viewArtwork.productImage' | transloco" class="product-main-image">
            </div>
            <ng-container *ngIf="(selectedItem.IsGalleryProduct || selectedItem.IsArtistOwnProduct) && selectedItem">
                <div class="d-flex flex-wrap  mt-3  ms-3">
                    <div *ngFor="let productImage of productImages" class="position-relative mt-2 me-2"
                        (mouseenter)="handleImageHover(productImage, true)"
                        (mouseleave)="handleImageHover(productImage, false)">
                        <div class="image-container position-relative"
                            [class.covered]="productImage.ImageUrl == selectedItem.ProductImgUrl">
                            <img [src]="productImage.ImageUrl" class="rounded-cube img-thumbnail"
                                style="width: 115px; height: 115px; border:none;">
                            <div class="hover-content position-absolute top-50 start-50 translate-middle"
                                [class.show]="productImage.ImageUrl != selectedItem.ProductImgUrl && productImage.hovered">
                                <!-- Set cover button -->
                                <button type="button"
                                    class="btn btn-sm btn-primary transparent-button p-button-outlined"
                                    [disabled]="productImage.ImageUrl == selectedItem.ProductImgUrl"
                                    (click)="updateSocialPostCoverimage(productImage)">
                                    <i class="fa fa-check text-white blurred-check"></i>
                                </button>
                                <div class="message-bottom position-absolute start-0 bottom-0 ms-1 mb-1"
                                    style="width: 106px;" *ngIf="productImage.ImageUrl == selectedItem.ProductImgUrl">
                                    <!-- Message displayed at the bottom for the cover image -->
                                    <div class="message-overlay">
                                        <div class="text-center text-white">
                                            {{ 'viewArtwork.selected' | transloco }} <i class="fa fa-check text-white blurred-check"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Badge for artist's image (always visible if it's an artist's image) -->
                            <div *ngIf="authConfig.IsGallery">
                                <div class="position-absolute top-0 right-2 end-0  small"
                                    *ngIf="!productImage.IsGalleryImg">
                                    <span class="badge bg-secondary text-white small  fw-0">{{ 'viewArtwork.artistsImage' | transloco }}</span>
                                </div>
                            </div>
                            <div *ngIf="authConfig.IsArtist">
                                <div class="position-absolute top-0 end-0 right-5 small"
                                    *ngIf="productImage.IsGalleryImg">
                                    <span class="badge bg-secondary text-white text-small">{{ 'viewArtwork.gallerysImage' | transloco }}</span>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="authConfig.IsGallery">
                            <div class="position-absolute top-0 end-0 m-2" *ngIf="productImage.IsGalleryImg">
                                <!-- Remove button (only visible if this photo is not the cover photo of the product) -->
                                <p-button type="button" size="small" [outlined]="false" severity="danger"
                                    (click)="deleteImage(productImage)">
                                    <i class="fa fa-times"></i>
                                </p-button>
                            </div>
                        </div>
                        <div class="position-absolute top-0 end-0 m-2"
                            *ngIf="productImage.ImageUrl && isProductAvailable">
                            <p-button type="button" size="small" [outlined]="false" severity="danger"
                                (click)="deleteImage(productImage)">
                                <i class="fa fa-times"></i>
                            </p-button>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>

        <div class="mt-3">
            <label class="form-label mb-2" for="floatingTextareaHeadline">{{ 'viewArtwork.yourHeadlineHere' | transloco }}</label>
            <textarea class="form-control" id="floatingTextareaHeadline" [(ngModel)]="selectedItem.SerialNumber"
                [ngModelOptions]="{standalone: true}" [placeholder]="'viewArtwork.yourHeadlineHere' | transloco">
            </textarea>
        </div>

        <div *ngIf="(selectedItem.IsGalleryProduct || selectedItem.IsArtistOwnProduct) && selectedItem">
            <ng-container>
                <label class="form-label" for="floatingTextareaDescription">{{ 'viewArtwork.postContentHere' | transloco }}</label>
                <textarea class="form-control" id="floatingTextareaDescription" cols="4" rows="4"
                    [(ngModel)]="galleryDescription.GalleryShortDescription" [ngModelOptions]="{standalone: true}"
                    [placeholder]="'viewArtwork.postContentHere' | transloco">
                </textarea>
            </ng-container>
        </div>

        <div class="d-flex mt-3">
            <button class="btn btn-outline-primary btn-sm px-2 py-2" [class.w-50]="isFacebook && isInstagram"
                [class.w-100]="isFacebook && !isInstagram" *ngIf="isFacebook" (click)="onOpenFacebookShare()">
                <img src="assets/images/social post icons/facebook.png" alt="pic" width="20" height="auto" class="mb-1">
                <span class="ms-1">{{ 'viewArtwork.postOnFacebook' | transloco }}</span>
            </button>
            <button class="btn btn-outline-primary btn-sm ms-2 px-2 py-2" [class.w-50]="isFacebook && isInstagram"
                [class.w-100]="!isFacebook && isInstagram" *ngIf="isInstagram" (click)="onOpenInstagramShare()">
                <img src="assets/images/social post icons/instagram.png" alt="pic" width="20" height="auto"
                    class="mb-1">
                <span class="ms-1">{{ 'viewArtwork.postOnInstagram' | transloco }}</span>
            </button>
        </div>
    </form>
</p-dialog>


<ng-container *ngIf="showCropperDialog">
    <app-image-cropper [showCropperDialog]="showCropperDialog" [isAdditionalImage]="isAdditionalImage"
        [image]="currentSelectedImageToCrop" (onImageCropped)="onImageCropped($event)"
        (onImageCropperClose)="onImageCropperClose($event)">
    </app-image-cropper>
</ng-container>


<ng-container *ngIf="showchatGPTDialog && selectedItem ">
    <chatgpt-dialog [displayDialog]="showchatGPTDialog" [artistProductId]="selectedItem.Id"
        [description]="selectedItem.GalleryShortDescription ? selectedItem.GalleryShortDescription : selectedItem.ShortDescription"
        (onUseGeneratedSuggestion)="onUseGeneratedProductSuggestions($event)" (onClose)="closechatGPTDialog($event)">
    </chatgpt-dialog>
</ng-container>




<!-- <p-dialog [showHeader]="true" header="Artwork Synchronization" [(visible)]="isProfileDialogVisible" [modal]="true"
    [style]="{ 'width': '620px' }">
    <p class="mb-3 mt-2  fs-5 p-2">
        Manage and configure the synchronization of your artworks with various platforms. Use the options below to
        enable or disable synchronization as needed.
    </p>
    <div class="d-flex justify-content-between align-items-center border-bottom p-2 w-100 ">
        <div class="d-flex flex-column flex-grow-1 w-100">
           
            <div class="text-small text-muted mt-2">
                <ng-container *ngIf="!squareUpAccount">
                    To start synchronizing your artworks with SquarePOS, please connect your SquarePOS account.
                </ng-container>
                <ng-container *ngIf="squareUpAccount">
                    Your account is connected. You can now sync your artworks with SquarePOS.
                </ng-container>
            </div>
        </div>

        <div *ngIf="!squareUpAccount">
            <button pButton type="button" class="p-button-danger p-button-outlined p-button-sm" label="Connect"
                (click)="onConnectSquareupPosAccount()" icon="pi pi-credit-card">
            </button>
        </div>
        <div *ngIf="squareUpAccount">
            <i class="pi pi-check text-success" style="font-size: 1.5rem;"></i>
        </div>
    </div>

    <div class="d-flex justify-content-between align-items-center border-bottom p-2 w-100">
        <div class="d-flex flex-column flex-grow-1 w-100">
          
            <div class="text-small text-muted mt-2">
                <ng-container *ngIf="!shopifyAccount">
                    To start synchronizing your artworks with Shopify, please connect your Shopify account.
                </ng-container>
                <ng-container *ngIf="shopifyAccount">
                    Your account is connected. You can now sync your artworks with Shopify.
                </ng-container>
            </div>
        </div>
        <div *ngIf="!shopifyAccount">
            <button pButton type="button" class="p-button-danger p-button-outlined p-button-sm" label="Connect"
                (click)="onShowShopifyConnectionDailog()" icon="pi pi-credit-card">
            </button>
        </div>
        <div *ngIf="shopifyAccount">
            <i class="pi pi-check text-success" style="font-size: 1.5rem;"></i>
        </div>
    </div>

    <div class="d-flex justify-content-between align-items-center border-bottom p-2 w-100">
        <div class="d-flex flex-column flex-grow-1 w-100">
           
            <div class="text-small text-muted mt-2">
                <ng-container *ngIf="!wooCommerceAccount">
                    To start synchronizing your artworks with WooCommerce, please connect your WooCommerce account.
                </ng-container>
                <ng-container *ngIf="wooCommerceAccount">
                    Your account is connected. You can now sync your artworks with WooCommerce.
                </ng-container>
            </div>
        </div>
        <div *ngIf="!wooCommerceAccount">
            <button pButton type="button" class="p-button-danger p-button-outlined p-button-sm" label="Connect"
                (click)="onShowWoocommerceAccountDailog()" icon="pi pi-credit-card">
            </button>
        </div>
        <div *ngIf="wooCommerceAccount">
            <i class="pi pi-check text-success" style="font-size: 1.5rem;"></i>
        </div>
    </div>

    <div class="d-flex justify-content-between align-items-center border-bottom p-2 w-100">
        <div class="d-flex flex-column flex-grow-1 w-100">
         
            <div class="text-small text-muted mt-2">
                <ng-container *ngIf="!checkAccountExitsOnWix">
                    To start synchronizing your artworks with Wix, please connect your Wix account.
                </ng-container>
                <ng-container *ngIf="checkAccountExitsOnWix">
                    Your account is connected. You can now sync your artworks with Wix.
                </ng-container>
            </div>
        </div>
        <div *ngIf="!checkAccountExitsOnWix">
            <button pButton type="button" class="p-button-danger p-button-outlined p-button-sm" label="Connect"
                (click)="connectWithWixAccount()" icon="pi pi-credit-card">
            </button>
        </div>
        <div *ngIf="checkAccountExitsOnWix">
            <i class="pi pi-check text-success" style="font-size: 1.5rem;"></i>
        </div>
    </div>

    <div class="d-flex justify-content-center mt-4">
        <button pButton type="button" class="p-button p-button-rounded w-100 p-button-outlined" label="Save Changes"
            (click)="updateArtworkSynchronizationPermission()" icon="fa fa-save">
        </button>
    </div>
</p-dialog> -->


<ng-container *ngIf="isShopifyConnectionDailogVisible">
    <shopify-and-woocommerce-dailog [platform]="'shopify'"
        [isAddPlatformAccountDailogVisible]="isShopifyConnectionDailogVisible"
        (onClosePlatformCredentialDailog)="onCloseShopifyConnectionDailog($event)"></shopify-and-woocommerce-dailog>
</ng-container>

<ng-container *ngIf="isAddWoocommerceAccountDailogVisible">
    <shopify-and-woocommerce-dailog [platform]="'woocommerce'"
        [isAddPlatformAccountDailogVisible]="isAddWoocommerceAccountDailogVisible"
        (onClosePlatformCredentialDailog)="onCloseWoocommerceAccountDailog($event)"></shopify-and-woocommerce-dailog>
</ng-container>



<ng-container *ngIf="isStripeDisplayPlansDialogVisible">
    <stripe-payment-plan [isStripePaymentPlansDialogVisible]="isStripeDisplayPlansDialogVisible"
        [stripeAllPlans]="stripePlans"
        (onCloseStripePaymentPlanDailog)="onCloseStripePaymentDailog($event)"></stripe-payment-plan>
</ng-container>


<ng-container *ngIf="displayCurrencyDialog">
    <app-currency-exchange-dialog [displayCurrencyDialog]="displayCurrencyDialog" [selectedItem]="selectedItem"
        [selectedPlatform]="platform" (closeDialog)="onCloseDialog()">
    </app-currency-exchange-dialog>
</ng-container>
<p-sidebar [(visible)]="sidebarVisible" position="right" [style]="{'width': '440px'}"
    [modal]="false" [closeOnEscape]="true" [showCloseIcon]="true" styleClass="custom-sidebar"
    (onHide)="onSidebarHidden($event)">
    <!-- Limited Access Alert for Free Plan Users -->
    <div *ngIf="isFreePlanUser && authConfig.IsGallery && selectedItem?.IsGalleryProduct"
        class="alert alert-warning p-3 rounded-3 border-0 shadow-sm mb-2">
        <div class="d-flex align-items-center">
            <i class="pi pi-info-circle text-warning fs-3 me-3"></i>
            <div class="flex-grow-1">
                <div class="fw-bold fs-5">{{ 'viewArtwork.limitedAccess' | transloco }}</div>
                <strong class="ms-2">{{ 'viewArtwork.currentPlanFree' | transloco }}</strong> {{ 'viewArtwork.upgradeToProAccess' | transloco }}
            </div>
        </div>
        <div class="text-center mt-2">
            <a href="javascript:void(0);" (click)="onUpgradePlan()">
                <img src="assets/images/upgrade-nag-button-200h.png" width="300" [alt]="'viewArtwork.upgradePlan' | transloco"
                    class="rounded shadow-lg img-fluid" />
            </a>
        </div>
    </div>

    <!-- Sync Buttons for Square, Shopify, Wix, and WooCommerce -->
    <div *ngIf="authConfig.IsGallery && selectedItem.IsGalleryProduct && !isProductSold" class="p-2">
        <!-- ACCOUNT CONNECTIONS section will only show if not all accounts are connected -->
        <div class="section rounded p-3 shadow-sm mb-2"
            *ngIf="!squareUpAccount || !shopifyAccount || !wooCommerceAccount || !checkAccountExitsOnWix">
            <div class="fw-bold mt-2 text-white p-2 rounded mb-3 section-header">
                {{ 'viewArtwork.accountConnections' | transloco }}
            </div>

            <div *ngIf="squareUpAccount || shopifyAccount || isWoocommerce || isWix">
                <p>{{ 'viewArtwork.connectAccountsToSync' | transloco }}</p>
            </div>
            <!-- SquareUp Account Connection -->
            <ng-container *ngIf="!squareUpAccount">
                <div *ngIf="!squareUpAccount"
                    class="d-flex justify-content-between align-items-center border-bottom p-2">
                    <div class="d-flex align-items-center">
                        <img src="assets/images/square-log.png" alt="SquareUp Logo" class="rounded-circle"
                            style=" height: 25px;" class="me-2">
                        <span>{{ 'viewArtwork.connectSquareUpPrompt' | transloco }}</span>
                    </div>
                    <div class="justify-content-end d-flex">
                        <button pButton type="button " class=" p-button-danger p-button-outlined  p-button-sm "
                            [label]="'viewArtwork.connect' | transloco" (click)="onConnectSquareupPosAccount()" [disabled]="isFreePlanUser">
                        </button>
                    </div>
                </div>
            </ng-container>

            <!-- Shopify Account Connection -->
            <ng-container *ngIf="!wooCommerceAccount">
                <div *ngIf="!shopifyAccount"
                    class="d-flex justify-content-between align-items-center border-bottom p-2">
                    <div class="d-flex align-items-center">
                        <img src="assets/images/shopify-log.png" alt="Shopify Logo" style=" height: 25px;" class="me-2">
                        <span>{{ 'viewArtwork.connectShopifyPrompt' | transloco }}</span>
                    </div>
                    <div class="justify-content-end  d-flex">
                        <button pButton type="button" class="p-button-danger p-button-outlined  p-button-sm"
                            [label]="'viewArtwork.connect' | transloco" (click)="onShowShopifyConnectionDailog()" [disabled]="isFreePlanUser">
                        </button>
                    </div>
                </div>
            </ng-container>

            <!-- WooCommerce Account Connection -->
            <ng-container *ngIf="!wooCommerceAccount">
                <div *ngIf="!wooCommerceAccount"
                    class="d-flex justify-content-between align-items-center border-bottom p-2">
                    <div class="d-flex align-items-center">
                        <img src="assets/images/woocommerace-log.png" alt="WooCommerce Logo" style=" height: 25px;"
                            class="me-2">
                        <span>{{ 'viewArtwork.connectWooCommercePrompt' | transloco }}</span>
                    </div>
                    <div class="justify-content-end d-flex">
                        <button pButton type="button" class="p-button-danger p-button-outlined p-button-sm "
                            [label]="'viewArtwork.connect' | transloco" (click)="onShowWoocommerceAccountDailog()" [disabled]="isFreePlanUser">

                        </button>
                    </div>
                </div>
            </ng-container>

            <!-- Wix Account Connection -->
            <ng-container *ngIf="!checkAccountExitsOnWix">
                <div *ngIf="!checkAccountExitsOnWix"
                    class="d-flex justify-content-between align-items-center border-bottom p-2">
                    <div class="d-flex align-items-center">
                        <img src="assets/images/wix-logo.png" alt="Wix Logo" style=" height: 25px;" class="me-2">
                        <span>{{ 'viewArtwork.connectWixPrompt' | transloco }}</span>
                    </div>
                    <div class="d-flex justify-content-end">
                        <button pButton type="button" class="p-button-danger p-button-outlined p-button-sm "
                            [label]="'viewArtwork.connect' | transloco" (click)="connectWithWixAccount()" [disabled]="isFreePlanUser">
                        </button>

                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="!checkAccountOnSquareSpace">
                <div *ngIf="!checkAccountExitsOnWix"
                    class="d-flex justify-content-between align-items-center border-bottom p-2">
                    <div class="d-flex align-items-center">
                        <img src="assets/images/squarespace.svg" alt="Square Space Logo" style=" height: 25px;"
                            class="me-2">
                        <span>{{ 'viewArtwork.connectSquareSpacePrompt' | transloco }}</span>
                    </div>
                    <div class="d-flex justify-content-end">
                        <button pButton type="button" class="p-button-danger p-button-outlined p-button-sm "
                            [label]="'viewArtwork.connect' | transloco" (click)="connectWithsquarespace()" [disabled]="isFreePlanUser">
                        </button>
                    </div>
                </div>
            </ng-container>

            <!-- Synchronization Options Section -->


        </div>
        <div class="section rounded p-3 shadow-sm mb-2" *ngIf="!isFreePlanUser ">
            <div class="fw-bold mt-2 text-white p-2 rounded mb-2 section-header">
                {{ 'viewArtwork.synchronizationOptions' | transloco }}
            </div>

            <p class="text-secondary">{{ 'viewArtwork.choosePreferredPlatform' | transloco }}</p>

        </div>

        <!-- Synchronization Options Section -->
        <div class="section rounded p-3 shadow-sm mb-2"
            *ngIf="!isFreePlanUser && (squareUpAccount || shopifyAccount || wooCommerceAccount || checkAccountExitsOnWix ||checkAccountOnSquareSpace)">


            <!-- Sync with SquareUp Button -->
            <ng-container *ngIf="squareUpAccount">
                <button *ngIf="!selectedItem.SquarePosProductId && squareUpAccount" pButton type="button"
                    class="btn btn-outline-primary btn-block mb-2 ms-2 " [disabled]="isFreePlanUser"
                    (click)="checkAndSyncProduct('SquareUp')">
                    {{ 'viewArtwork.syncWithSquareUp' | transloco }}
                </button>
            </ng-container>

            <!-- Sync with Shopify Button -->
            <ng-container *ngIf="shopifyAccount">
                <button *ngIf="!selectedItem.ShopifyProductId && shopifyAccount" pButton type="button"
                    class="btn btn-outline-primary btn-block mb-2 ms-3 " [disabled]="isFreePlanUser"
                    (click)="checkAndSyncProduct('Shopify')">
                    {{ 'viewArtwork.syncWithShopify' | transloco }}
                </button>
            </ng-container>

            <!-- Sync with WooCommerce Button -->
            <ng-container *ngIf="wooCommerceAccount">
                <button *ngIf="wooCommerceAccount" pButton type="button"
                    class="btn btn-outline-primary btn-block mb-2 ms-2 " [disabled]="isFreePlanUser"
                    (click)="checkAndSyncProduct('WooCommerce')">
                    {{ 'viewArtwork.syncWithWooCommerce' | transloco }}
                </button>
            </ng-container>

            <!-- Sync with Wix Button -->
            <ng-container *ngIf="checkAccountExitsOnWix">
                <button *ngIf="!selectedItem.WixProductId && checkAccountExitsOnWix" pButton type="button"
                    class="btn btn-outline-primary btn-block mb-2 ms-3" [disabled]="isFreePlanUser"
                    (click)="checkAndSyncProduct('Wix')">
                    {{ 'viewArtwork.syncWithWix' | transloco }}
                </button>
            </ng-container>
            <!-- Sync with Square Space Button -->
            <ng-container *ngIf="checkAccountOnSquareSpace">
                <button pButton type="button" class="btn btn-outline-primary btn-block mb-2 ms-3"
                    [disabled]="isFreePlanUser" (click)="checkAndSyncProduct('SquareSpace')">
                    {{ 'viewArtwork.syncWithSquareSpace' | transloco }}
                </button>
            </ng-container>
            <ng-container
                *ngIf="!squareUpAccount && !shopifyAccount && !wooCommerceAccount && !checkAccountExitsOnWix && !checkAccountOnSquareSpace">
                <div class="d-flex justify-content-center align-items-center mt-3 p-3">
                    {{ 'viewArtwork.noSyncPermissions' | transloco }}
                </div>
            </ng-container>
        </div>

        <!-- Section: Synced Platforms -->
        <div class="d-flex flex-column align-items-center">
            <!-- Synced with SquareUp -->
            <ng-container *ngIf="squareUpAccount">
                <div *ngIf="selectedItem.SquarePosProductId"
                    class="d-flex align-items-center justify-content-between w-100 mb-3">
                    <div class="text-muted">{{ 'viewArtwork.syncedWithSquareUp' | transloco }}</div>
                    <div>
                        <ng-container *ngIf="!isProductSold; else soldSquare">
                            <a [href]="selectedItem.SquarePosStoreUrl" target="_blank" [title]="'viewArtwork.viewOnSquareUp' | transloco">
                                <img src="assets/images/square-log.png" alt="SquareUp Logo" class="rounded"
                                    style="height: 40px; width: 40px; transition: transform 0.3s;">
                            </a>
                        </ng-container>
                        <ng-template #soldSquare>
                            <img src="assets/images/square-log.png" alt="SquareUp Logo" class="rounded"
                                style="height: 40px; width: 40px; opacity: 0.5;">
                        </ng-template>
                    </div>
                </div>
            </ng-container>

            <!-- Synced Platforms Section -->
            <ng-container
                *ngIf="selectedItem?.ProductSyncedOnPlatformDTOs && selectedItem.ProductSyncedOnPlatformDTOs.length > 0">
                <!-- Shopify -->
                <ng-container *ngIf="shopifyAccount">
                    <div *ngIf="shopifyStores.length > 0"
                        class="d-flex align-items-center justify-content-between w-100 mb-3 mt-4 p-2">
                        <div class="text-muted">{{ 'viewArtwork.syncedWithShopify' | transloco }}</div>
                        <div>
                            <ng-container *ngIf="!isProductSold; else soldShopify">
                                <div [title]="'viewArtwork.viewOnShopify' | transloco" (click)="openShopifyLinksDialog()">
                                    <img src="assets/images/shopify-log.png" alt="Shopify Logo" class="rounded"
                                        style="height: 40px; width: 40px; transition: transform 0.3s; cursor: pointer;">
                                </div>
                            </ng-container>
                            <ng-template #soldShopify>
                                <img src="assets/images/shopify-log.png" alt="Shopify Logo" class="rounded"
                                    style="height: 40px; width: 40px; opacity: 0.5;">
                            </ng-template>
                        </div>
                    </div>
                </ng-container>
                <!-- WooCommerce -->
                <ng-container *ngIf="wooCommerceAccount">
                    <div *ngIf="wooCommerceStores.length > 0"
                        class="d-flex align-items-center justify-content-between w-100 mb-3">
                        <div class="text-muted">{{ 'viewArtwork.syncedWithWooCommerce' | transloco }}</div>
                        <div>
                            <ng-container *ngIf="!isProductSold; else soldWooCommerce">
                                <div [title]="'viewArtwork.viewOnWooCommerce' | transloco" (click)="openWooCommerceLinksDialog()">
                                    <img src="assets/images/woocommerace-log.png" alt="WooCommerce Logo" class="rounded"
                                        style="height: 40px; width: 40px; transition: transform 0.3s; cursor: pointer;">
                                </div>
                            </ng-container>
                            <ng-template #soldWooCommerce>
                                <img src="assets/images/woocommerace-log.png" alt="WooCommerce Logo" class="rounded"
                                    style="height: 40px; width: 40px; opacity: 0.5;">
                            </ng-template>
                        </div>
                    </div>
                </ng-container>
                <!-- SquareSpace -->
                <ng-container *ngIf="checkAccountOnSquareSpace">
                    <div *ngIf="squareSpaceStores.length > 0"
                        class="d-flex align-items-center justify-content-between w-100 mb-3">
                        <div class="text-muted">{{ 'viewArtwork.syncedWithSquareSpace' | transloco }}</div>
                        <div>
                            <ng-container *ngIf="!isProductSold; else soldSquareSpace">
                                <div [title]="'viewArtwork.viewOnSquareSpace' | transloco" (click)="openSquareSpaceLinksDialog()">
                                    <img src="assets/images/squarespace.svg" alt="Square Space Logo" class="rounded"
                                        style="height: 40px; width: 40px; transition: transform 0.3s; cursor: pointer;">
                                </div>
                            </ng-container>
                            <ng-template #soldSquareSpace>
                                <img src="assets/images/squarespace.svg" alt="Square Space Logo" class="rounded"
                                    style="height: 40px; width: 40px; opacity: 0.5;">
                            </ng-template>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
            <!-- Synced with Wix -->
            <ng-container *ngIf="checkAccountExitsOnWix">
                <div *ngIf="selectedItem.WixProductId"
                    class="d-flex align-items-center justify-content-between w-100 mb-3">
                    <div class="text-muted">{{ 'viewArtwork.syncedWithWix' | transloco }}</div>
                    <div>
                        <ng-container *ngIf="!isProductSold; else soldWix">
                            <a [href]="selectedItem.WixProductLink" target="_blank" [title]="'viewArtwork.viewOnWix' | transloco">
                                <img src="assets/images/wix-logo.png" alt="Wix Logo" class="rounded"
                                    style="height: 40px; width: 40px; transition: transform 0.3s;">
                            </a>
                        </ng-container>
                        <ng-template #soldWix>
                            <img src="assets/images/wix-logo.png" alt="Wix Logo" class="rounded"
                                style="height: 40px; width: 40px; opacity: 0.5;">
                        </ng-template>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</p-sidebar>